import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './organization-delete-modal';

class OrganizationDeleteButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: 0.5rem;
      }
    `];
  }

  render() {
    return html`
      <button class="button button--outlinedError" @click="${this._onClick}">
        <bn-icon name="far fa-trash-alt"></bn-icon>
        Delete Organization
      </button>

      <organization-delete-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></organization-delete-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('organization-delete-button', OrganizationDeleteButton);
